import { render, staticRenderFns } from "./voucherVisualizadoFamilia.vue?vue&type=template&id=5aac43bf"
import script from "./voucherVisualizadoFamilia.vue?vue&type=script&lang=js"
export * from "./voucherVisualizadoFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports